module.exports = __webpack_public_path__ + "img/no-positions.bb38fb38.png";